import React from 'react';


export function Thumbnail({
  imageUrl,
  title
}) {
  return (
    <div className="thumbnail">
      <div className="thumbnail__image" style={ { backgroundImage: `url(${imageUrl})` } }></div>
      <p className="thumbnail__excerpt">{ title }</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedVideos/components/thumbnail.js